import {useState} from 'react';
import {sortData} from '../../../content/dropdownData';
import * as Styled from './DropdownStyled';

const Dropdown = ({setSortName}: any) => {
  const [isDropdownShown, setDropdownShown] = useState(false);
  const [shownItem, setShownItem] = useState('Sort by');

  let dropdownItems = 'DropdownItems';
  if(isDropdownShown){
    dropdownItems += ' d-flex';
  }
  else{
    dropdownItems += ' d-none';
  }
  return (
    <Styled.Container className='DropdownWrapper'>
      <Styled.Container className='ShownItem' onClick={()=>setDropdownShown(currValue => !currValue)}>
        <span >{shownItem}</span>
      </Styled.Container>
      <Styled.Container className={dropdownItems}>
        {
          sortData.map( (e,i) => {
            return (
            <Styled.StyledSpan key={i}
              onClick={() => {
                setSortName(e.name);
                setShownItem(e.name);
                setDropdownShown(false);
              }}
            >
              {e.name}
            </Styled.StyledSpan>
            );
          })
        }
      </Styled.Container>
    </Styled.Container>
  );
}

export default Dropdown;